module.exports = __webpack_public_path__ + "img/chat_widget_logo.000f5a8f.png";